import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.431 2.821a.7.7 0 0 1 .604.197l6.576 6.575a.7.7 0 0 1 0 .99l-6.028 6.028a.7.7 0 0 1-.99 0l-6.575-6.576a.7.7 0 0 1-.197-.604l.822-5.205a.7.7 0 0 1 .582-.583zM4.947 4.947l-.687 4.35 5.828 5.83 5.038-5.039L9.297 4.26z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.537 6.777a.76.76 0 1 1-1.519 0 .76.76 0 0 1 1.519 0"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=TagIcon20.js.map